"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = require("draft-js");
var editor_1 = require("@draft-js-plugins/editor");
var image_1 = __importDefault(require("@draft-js-plugins/image"));
var focus_1 = __importDefault(require("@draft-js-plugins/focus"));
var components_1 = require("./components");
function linkPluginStrategy(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === "LINK");
    }, callback);
}
function getContentEditorPlugins(readOnly) {
    var linkPlugin = {
        keyBindingFn: function (event, _a) {
            var getEditorState = _a.getEditorState;
            var editorState = getEditorState();
            var selection = editorState.getSelection();
            if (selection.isCollapsed()) {
                return;
            }
            if (draft_js_1.KeyBindingUtil.hasCommandModifier(event) && event.which === 75) {
                return "add-link";
            }
        },
        decorators: [
            {
                strategy: linkPluginStrategy,
                component: components_1.ContentEditorLink,
            },
        ],
    };
    var plugins = [linkPlugin];
    if (readOnly) {
        var imagePlugin = (0, image_1.default)();
        plugins = __spreadArray(__spreadArray([], plugins, true), [imagePlugin], false);
    }
    else {
        var focusPlugin = (0, focus_1.default)();
        var decorator = (0, editor_1.composeDecorators)(focusPlugin.decorator);
        var imagePlugin = (0, image_1.default)({ decorator: decorator });
        plugins = __spreadArray(__spreadArray([], plugins, true), [focusPlugin, imagePlugin], false);
    }
    return plugins;
}
exports.default = getContentEditorPlugins;
//# sourceMappingURL=plugins.js.map